import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { useUserAuth } from "@/contexts/UserAuthContext";
import { useUserProfile } from "@/hooks/useCashback";
import { ReferralSection } from "@/components/account/ReferralSection";

export default function ReferralPage() {
  const navigate = useNavigate();
  const { user } = useUserAuth();
  const { profile } = useUserProfile(user?.uid ?? null);

  return (
    <div className="flex flex-col flex-1 min-h-0 bg-background">
      <div className="flex items-center justify-between gap-3 px-4 pt-12 pb-5 shrink-0">
        <h1 className="text-xl font-bold text-foreground">الإحالة</h1>
        <button
          onClick={() => navigate(-1)}
          className="w-10 h-10 rounded-full bg-primary text-primary-foreground flex items-center justify-center shrink-0 active:opacity-90 transition-opacity ring-2 ring-white/20 shadow-sm"
        >
          <ChevronLeft className="w-5 h-5" strokeWidth={2.5} />
        </button>
      </div>

      <div className="flex-1 min-h-0 overflow-y-auto pb-6">
        <ReferralSection referralCode={profile?.referralCode} userId={user?.uid} />
      </div>
    </div>
  );
}

